import React from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';

import MediaForm from './MediaForm';

const styles = theme => ({
  content: {
    // padding: theme.spacing(3),
    backgroundColor: theme.palette.primary.main,
    borderTop: theme.palette.component.borderOutline,
  },
});

const MediaMain = props => {
  const { classes } = props;

  return (
    <React.Fragment>
      <div className={clsx(classes.content)}>
        <MediaForm {...props} />
      </div>
    </React.Fragment>
  );
};

export default withStyles(styles)(MediaMain);
